import { useState } from 'react'
import { Modal, Stack, Alert, TextInput, PasswordInput, Group, Button } from '@mantine/core'
import { IconAlertCircle, IconX } from '@tabler/icons-react'

export default function ConfirmEmailModal({ opened, onClose, email, onConfirm, ...rest }) {
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)

    const isValid = password.length > 0 && password === confirmPassword

    async function handleConfirm() {
        if (onConfirm) {
            setLoading(true)
            setError(null)
            try {
                await onConfirm(password)
                onClose()
            } catch (error) {
                let isUserExists = false

                // Check if errors array exists directly on error (CombinedGraphQLErrors)
                if (error?.errors?.length > 0) {
                    console.log('Direct Errors:', error.errors)
                    isUserExists = error.errors.some(
                        err => err?.extensions?.code === 'USER_EXISTS'
                    )
                }

                if (isUserExists) {
                    setError('That email address is already registered. Try logging in, or reset your password on the login form if necessary.')
                } else {
                    setError('Registration failed. Please try again.')
                }
            } finally {
                setLoading(false)
            }
        }
    }

    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title="Confirm Account Details"
            size="md"
            centered
            {...rest}
        >
            <Stack gap="md" style={{ marginTop: '1em' }}>
                {error && (
                    <Alert
                        color="red"
                        variant="light"
                        icon={<IconX size={16} />}
                    >
                        {error}
                    </Alert>
                )}

                <Alert
                    color="blue"
                    variant="light"
                    icon={<IconAlertCircle size={16} />}
                >
                    Setting your email address will make your account permanent, but will require you to verify the email address you provide. Please confirm it is correct before proceeding.  If everything looks good, set your password and click "Confirm & Register" to complete the process.
                </Alert>

                <TextInput
                    label="Email Address"
                    value={email}
                    disabled
                    size="sm"
                />

                <PasswordInput
                    label="Password"
                    placeholder="Enter password"
                    value={password}
                    onChange={(e) => setPassword(e.currentTarget.value)}
                    size="sm"
                    required
                />

                <PasswordInput
                    label="Confirm Password"
                    placeholder="Re-enter password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.currentTarget.value)}
                    size="sm"
                    required
                    error={confirmPassword.length > 0 && password !== confirmPassword ? 'Passwords do not match' : null}
                />

                <Group justify="flex-end" gap="sm">
                    <Button variant="subtle" onClick={onClose} disabled={loading}>
                        Cancel
                    </Button>
                    <Button
                        onClick={handleConfirm}
                        disabled={!isValid}
                        loading={loading}
                    >
                        Confirm & Register
                    </Button>
                </Group>
            </Stack>
        </Modal>
    )
}

